import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String
  }

  static targets = ['button'] // Define the button as a target

  declare urlValue: string
  declare buttonTarget: HTMLButtonElement

  print(event: Event): void {
    console.log('Printing...')
    event.preventDefault()

    const printFrame = document.createElement('iframe')

    printFrame.style.display = 'none'
    printFrame.src = this.urlValue

    printFrame.onload = () => {
      console.log(printFrame, printFrame.contentWindow)
      if (printFrame.contentWindow !== null) {
        printFrame.contentWindow.print()
      }
    }

    this.element.appendChild(printFrame)
  }
}
